import { render, staticRenderFns } from "./ShopOrderPanel.vue?vue&type=template&id=14afcf90&scoped=true"
import script from "./ShopOrderPanel.vue?vue&type=script&lang=js"
export * from "./ShopOrderPanel.vue?vue&type=script&lang=js"
import style0 from "./ShopOrderPanel.vue?vue&type=style&index=0&id=14afcf90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14afcf90",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QBanner});
